import { useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { useNavigation } from '@navigation';

interface IntroWizardHelperResources {
	title: string;
	subtitle: string;
	buttonText: string;
}

interface IntroWizardHelperOutput {
	resources: IntroWizardHelperResources;
	onPress: () => void;
}

export const useIntroWizardHelper = (): IntroWizardHelperOutput => {
	const t = useTranslation();
	const { navigate } = useNavigation();

	const resources: IntroWizardHelperResources = {
		title: t('placeholder.wizardIntro.title'),
		subtitle: t('placeholder.wizardIntro.subtitle'),
		buttonText: t('placeholder.wizardIntro.button.text'),
	};

	const onPress = () => {
		navigate('subscriptionPaymentOptions');
	};

	return { resources, onPress };
};
